import { render } from "./ExpiredIcon.vue?vue&type=template&id=4fc3e49b"
import script from "./ExpiredIcon.vue?vue&type=script&lang=js"
export * from "./ExpiredIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__